// based on rc-tree 2.1.3
'use strict';

module.exports = require('./src/');


//////////////////
// WEBPACK FOOTER
// ./~/ant-design-vue/es/vc-tree/index.js
// module id = 219
// module chunks = 0